/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

// Used to generate the requirejs layers bundle
// Only declare the entry points, not all modules!
define([
	'./actions/crosstab/HideShowSummariesAction',
	'./actions/crosstab/SwapRowColumnAction',
	'./dataSources/api/DataSourceAPI',
	'./dataSources/api/DataSourcesAPI',
	'./dataSources/api/DataSourcesUIAPI',
	'./dataSources/api/MetadataColumnAPI',
	'./vis-fredisred/FredIsRedModel'
], () => {});